import { render, staticRenderFns } from "./myproducts.vue?vue&type=template&id=724ebcf6"
import script from "./myproducts.vue?vue&type=script&lang=js"
export * from "./myproducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports